module.exports = __webpack_public_path__ + "static/media/wedding_party@2x.c09b4459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/wedding_party@2x.png
// module id = 1520
// module chunks = 43